import type { ModuleId } from '@/constants/modules'
import { MODULE_LABEL_TO_ID, getModuleTheme } from '@/constants/modules'

export function resolveModuleFromPath(pathname: string): ModuleId {
  if (pathname === '/' || pathname === '') return 'dashboard'
  if (pathname.startsWith('/master-data')) return 'master-data'
  if (pathname.startsWith('/sales')) return 'sales'
  if (pathname.startsWith('/inventory')) return 'inventory'
  if (pathname.startsWith('/production')) return 'production'
  if (pathname.startsWith('/dispatch')) return 'dispatch'
  if (pathname.startsWith('/purchases')) return 'purchases'
  if (pathname.startsWith('/finance') || pathname.startsWith('/company')) return 'finance'
  if (pathname.startsWith('/tasks')) return 'tasks'
  if (pathname.startsWith('/reports')) return 'reports'
  if (pathname.startsWith('/users')) return 'user-management'
  if (pathname.startsWith('/settings')) return 'settings'
  return 'dashboard'
}

export function resolveModuleLabel(label: string): ModuleId {
  return MODULE_LABEL_TO_ID[label] ?? 'dashboard'
}

export { getModuleTheme }
export type { ModuleId, ModuleTheme } from '@/constants/modules'

/**
 * Future module checklist (auto-themed when using shared primitives):
 * - Wrap pages in <PageLayout> (header colors from route)
 * - Tables: DataTableShell + TableHead + TableSortHeader + TablePagination
 * - Dialogs: <AppModal> or ConfirmDialog (module accent; destructive stays red)
 * - Empty: <EmptyState> · Cards: <SectionCard accent>
 * - Primary CTAs: className={useModuleTheme().actionBtn} (or default <Button> — both use module darker gradient)
 * - Row hover: theme.rowHover
 */
